module.exports = __webpack_public_path__ + "static/img/1.ad941f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R404A/1.jpg
// module id = XIu1
// module chunks = 1